/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMonthlyCostReport extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMonthlyCostReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMonthlyCostReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMonthlyCostReport>): BackgroundJobPayloadForPeriodicMonthlyCostReport {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMonthlyCostReport(), model);
        BackgroundJobPayloadForPeriodicMonthlyCostReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMonthlyCostReport>): BackgroundJobPayloadForPeriodicMonthlyCostReport {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMonthlyCostReport.newInstance(<BackgroundJobPayloadForPeriodicMonthlyCostReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMonthlyCostReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMonthlyCostReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMonthlyCostReport): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMonthlyCostReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
